var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import Closed from './Closed';
import Open from './Open';
import useData from './useData';
/**
 * Renders a block to select a Zap.
 */
const ZapBlock = (_a) => {
    var { accountId, children, onSelect, size = 'large', state, title, kind, kindDisplayName = 'Zap' } = _a, otherProps = __rest(_a, ["accountId", "children", "onSelect", "size", "state", "title", "kind", "kindDisplayName"]);
    const [search, setSearch] = useState('');
    const { error, isLoading, data } = useData({
        accountId,
        search,
        kind,
    });
    const isFiltered = !!search;
    if (state === 'closed' || state === 'confirm') {
        return (React.createElement(Closed, Object.assign({ data: data, isConfirming: state === 'confirm', isLoading: isLoading, kindDisplayName: kindDisplayName, onSelect: onSelect, size: size, title: title }, otherProps)));
    }
    return (React.createElement(Open, { data: data, error: error, isFiltered: isFiltered, isLoading: isLoading, kindDisplayName: kindDisplayName, onFilter: setSearch, onSelect: onSelect, size: size, title: title }, children));
};
export default ZapBlock;
